import { Info } from 'lucide-react';

interface SiteBrandingProps {
  onShowInfo?: () => void;
}

/**
 * Site branding header showing the application name and tagline.
 * Positioned in the top-left corner of the map.
 */
export function SiteBranding({ onShowInfo }: SiteBrandingProps) {
  return (
    <div className="fixed top-6 left-6 z-[1000]">
      <div className="glass rounded-lg shadow-glass px-4 py-3">
        <div className="flex items-start gap-2">
          <div>
            <h1 className="text-sm font-semibold text-text-primary tracking-wide uppercase">
              Regulatory Pulse
            </h1>
            <p className="text-[10px] text-text-tertiary mt-0.5">
              Real-time iGaming regulatory intelligence
            </p>
          </div>
          {onShowInfo && (
            <button
              onClick={onShowInfo}
              className="p-1 rounded hover:bg-white/10 text-text-tertiary hover:text-text-primary transition-colors"
              title="About this map"
              aria-label="About this map"
            >
              <Info className="h-3.5 w-3.5" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default SiteBranding;
